import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const aflt_departmentList = (request) => {
    let ENDPOINT = URL_BASE_API+'user/departments/';
    if(request.data!==undefined){
      let affiliateId = request.data.affiliateId?request.data.affiliateId:0;   
      let shiftId = request.data.shiftId?request.data.shiftId:0;
      let associated = request.data && request.data.associated?request.data.associated:0;
      ENDPOINT = URL_BASE_API+'user/departments/'; 
      let sepVal = '?'; 
      if(affiliateId) {
        ENDPOINT += sepVal+'affiliate='+affiliateId; 
        sepVal = '&'; 
      }
      if(shiftId) {
        ENDPOINT += sepVal+'shift_id='+shiftId; 
        sepVal = '&'; 
      }
      if(associated) {
        ENDPOINT += sepVal+'associated='+associated; 
        sepVal = '&'; 
      }
    }
    return service.get(ENDPOINT);    
}; 

export const aflt_departmentAdd = (request) => {
  const ENDPOINT = URL_BASE_API+'user/departments/';
  return service.post(ENDPOINT,request.data);  
};  

export const aflt_departmentUpdate = (request) => {
  let departmenttId = request.data.id;
  const ENDPOINT = URL_BASE_API+'user/department/'+departmenttId;
  return service.put(ENDPOINT,request.data);
};

export const aflt_departmentDelete = (request) => {
  let dptId = request.data.dptId;
  let confirm = request.data.confirm;
  let ENDPOINT = '';
  if(confirm!==undefined){
    ENDPOINT = URL_BASE_API+'user/department/'+dptId+'?delete_confirmation='+confirm;
  }else{
    ENDPOINT = URL_BASE_API+'user/department/'+dptId;
  }
  return service.delete(ENDPOINT);  
};   
